import React from "react";
import { Checkbox, DatePicker, Input, InputNumber } from "antd";

const TypeBasedInput = props => {
  const { dataType, inputValue, setInputValue, setMetricValue, metric } = props;

  switch (dataType) {
    case "String":
      return (
        <Input
          placeholder="Enter a value"
          allowClear
          onChange={e => {
            const value = e.target.value;
            setInputValue(value);
            setMetricValue({
              value: value,
              key: metric.key,
              name: metric.name,
              dataType: dataType,
            });
          }}
        />
      );
    case "Date":
      return (
        <DatePicker
          format="YYYY/MM/DD"
          onChange={e => {
            if (e === null) {
              setMetricValue({
                value: null,
                key: metric.key,
                name: metric.name,
                dataType: dataType,
              });
              return;
            } else {
              setMetricValue({
                value: e.format("YYYY/MM/DD"),
                key: metric.key,
                name: metric.name,
                dataType: dataType,
              });
              setInputValue(e);
            }
          }}
        />
      );
    case "Boolean":
      return (
        <Checkbox
          onChange={v => {
            const value = v.target.checked;
            setInputValue(value);
            setMetricValue({
              value: value ? 1 : 0,
              key: metric.key,
              name: metric.name,
              dataType: dataType,
            });
          }}
        />
      );
    case "Number":
      return (
        <InputNumber
          min={0} // Optionally, set minimum value
          step={1} // Optionally, set step size
          formatter={value => `${value}`} // Optionally, format display value
          parser={value => value.replace(/\$\s?|(,*)/g, "")} // Optionally, parse input value
          style={{ width: "100%" }}
          value={inputValue}
          onChange={value => {
            setInputValue(value);
            setMetricValue({
              value: value,
              key: metric.key,
              name: metric.name,
            });
          }}
        />
      );
    default:
      return null;
  }
};

export default TypeBasedInput;
